var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3934 48C37.8656 48 48.7869 37.2548 48.7869 24C48.7869 10.7452 37.8656 0 24.3934 0C10.9213 0 0 10.7452 0 24C0 37.2548 10.9213 48 24.3934 48Z",
    fill: "url(#paint0_linear_744_374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0418 23.7464C18.153 20.6982 22.8949 18.6886 25.2675 17.7176C32.0419 14.9454 33.4495 14.4638 34.367 14.4479C34.5688 14.4444 35.02 14.4936 35.3122 14.727C35.559 14.924 35.6269 15.1901 35.6594 15.3769C35.6919 15.5637 35.7324 15.9892 35.7002 16.3217C35.3331 20.1167 33.7447 29.3261 32.9365 33.5765C32.5946 35.375 31.9213 35.978 31.2695 36.037C29.8529 36.1653 28.7772 35.116 27.4052 34.2311C25.2583 32.8465 24.0454 31.9845 21.9614 30.6334C19.553 29.0719 21.1143 28.2136 22.4868 26.811C22.846 26.444 29.0875 20.8585 29.2083 20.3518C29.2234 20.2884 29.2374 20.0522 29.0948 19.9275C28.9521 19.8027 28.7416 19.8454 28.5897 19.8793C28.3744 19.9274 24.9446 22.1578 18.3004 26.5705C17.3269 27.2282 16.4451 27.5486 15.655 27.5318C14.7841 27.5133 13.1087 27.0473 11.8632 26.649C10.3355 26.1604 9.1214 25.9021 9.22712 25.0724C9.28219 24.6402 9.88709 24.1982 11.0418 23.7464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_374",
    x1: 2439.34,
    y1: 0,
    x2: 2439.34,
    y2: 4764.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.050f82735b6b68ddc228b39fb53d49c8.svg";
export { ForwardRef as ReactComponent };